
  import { css } from 'lit';
  export const styles = css`:host{--dot-size: var(--ig-badge-dot-size, max(var(--is-large, 1) * max(0.75rem, -1 * 0.75rem), var(--is-medium, 1) * max(0.625rem, -1 * 0.625rem), var(--is-small, 1) * max(0.375rem, -1 * 0.375rem)));--ig-theme: fluent;--ig-theme-variant: dark}`;
  